import { CircleAlert } from "lucide-react";
import { cn } from "@/app/utils/cn";
import { Skeleton } from "@/view/components/ui/skeleton";

type ValueSkeletonProps = {
  className?: string;
};

export const ValueSkeleton = ({ className }: ValueSkeletonProps) => (
  <Skeleton
    aria-label="Carregando"
    className={cn(
      "h-4 rounded-full bg-[#C4C4C4] bg-gradient-to-r from-[#CFCFCF] via-[#A8A8A8] to-[#CFCFCF]",
      className,
    )}
  />
);

export const ErrorValue = () => (
  <CircleAlert
    aria-label="Não foi possível consultar"
    className="size-4 text-destructive"
  />
);

type ProductSyncStatusProps = {
  isError: boolean;
  productLabel: string;
  className?: string;
};

export const ProductSyncStatus = ({
  isError,
  productLabel,
  className,
}: ProductSyncStatusProps) => {
  if (!isError) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "mt-5 flex items-start gap-2 rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-xs font-semibold text-destructive",
        className,
      )}
    >
      <CircleAlert aria-hidden className="mt-0.5 size-4 shrink-0" />
      <div className="space-y-1">
        <p>Erro na consulta</p>
        <p className="font-normal">
          Não foi possível consultar dados na API do {productLabel}, verifique
          novamente em alguns momentos
        </p>
      </div>
    </div>
  );
};
